import { defineSlotRecipe } from '@chakra-ui/react';

export const accordion = defineSlotRecipe({
  className: 'chakra-accordion',
  // eslint-disable-next-line i18next/no-literal-string -- slots not user facing
  slots: ['root', 'item', 'itemTrigger', 'itemContent', 'itemIndicator', 'itemBody'],
  base: {
    itemTrigger: {
      _hover: {
        background: 'blue.50',
      },
      paddingX: 4,
      fontWeight: 'normal',
    },
    itemIndicator: {
      color: 'fg',
    },
    itemContent: {
      paddingX: 4,
    },
  },
  variants: {
    size: {
      sm: {
        itemTrigger: {
          paddingX: 0,
          fontSize: 'md',
        },
        itemContent: {
          paddingX: 0.5,
        },
      },
      md: {
        itemIndicator: {
          _icon: {
            boxSize: 8,
            // Make icon oversized relative to container, without increasing accordion header height
            marginY: -1,
          },
        },
      },
    },
    variant: {
      outline: {
        item: {
          _first: {
            borderTop: '1px solid',
            borderColor: 'border',
          },
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
